var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":""}},[_vm._v(" Block Button ")])
}
var staticRenderFns = []

export { render, staticRenderFns }